export default __webpack_public_path__ + "static/media/mussila_logo.1eeefd6b.svg";